import request from '@/CommonDP/utils/request';
// 标准模板维护
export default {
  // 左侧修改为获取专业列表
  getSpecListStandard(enterpriseId) {
    return request.get(`/standardLayer/getProfessionalList?enterpriseId=${enterpriseId}`);
  },
  // 标准文件列表(刷新)
  selectDocumentList(params) {
    return request.get('/templateMaintenance/selectDocumentList', { params });
  },
  // 上传
  uploadStandardDocument(data) {
    return request.post('/templateMaintenance/uploadStandardDocument', data, { timeout: 0 });
  },
  // 删除
  deleteStandardDocument(params) {
    return request.get('/templateMaintenance/deleteStandardDocument', { params });
  },
  // 修改
  renameStandardDocument(params) {
    return request.post(`/templateMaintenance/renameStandardDocument`, params);
  },
  // 下载
  downloadStandardDocument(fileID) {
    return request({
      url: `/templateMaintenance/downloadStandardDocument/download/${fileID}`,
      method: 'get',
      responseType: 'blob'
    });
  },
  // 标准模板维护 revit样板维护
  getSpecTree(enterpriseId) {
    return request.get(`/cadFileTemplate/getSpecTree?enterpriseId=${enterpriseId}`);
  }
};
